/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for adding an administrator to an event.
 * @export
 * @interface EventAdministratorCreate
 */
export interface EventAdministratorCreate {
    /**
     * 
     * @type {string}
     * @memberof EventAdministratorCreate
     */
    user_id: string;
}

/**
 * Check if a given object implements the EventAdministratorCreate interface.
 */
export function instanceOfEventAdministratorCreate(value: object): value is EventAdministratorCreate {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    return true;
}

export function EventAdministratorCreateFromJSON(json: any): EventAdministratorCreate {
    return EventAdministratorCreateFromJSONTyped(json, false);
}

export function EventAdministratorCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventAdministratorCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
    };
}

export function EventAdministratorCreateToJSON(json: any): EventAdministratorCreate {
    return EventAdministratorCreateToJSONTyped(json, false);
}

export function EventAdministratorCreateToJSONTyped(value?: EventAdministratorCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
    };
}

